import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions/campaignActions';
import * as moment from 'moment';

const toOptionItem = record => {
  return {
    key: record,
    text: record,
    value: record,
  };
};

const initialValues = { subject: ' ', siteId: '', status: 'All', sendDate: '', style: '', pageSize: 50, offset: 0 };

const defaultState = {
  digest: {},
  hotw: {},
  hotws: [],
  promoAlert: {},
  promoAlerts: [],
  newsAlert: {},
  newsAlerts: [],
  digests: [],
  topPosts: [],
  searchPosts: [],
  recentPosts: [],
  listings: {},
  hotwQuery: initialValues,
  promoAlertQuery: initialValues,
  cityRinkQuery: { ...initialValues, style: 'City Rink' },
  dayOptions: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(toOptionItem),
};

const reducer = handleActions(
  {
    [combineActions(actions.getDigestByIdSuccess, actions.setCurrentDigest)]: (state, { payload: { digest } }) => {
      return { ...state, digest };
    },
    [combineActions(actions.getDigestsSuccess, actions.searchDigestsSuccess)]: (state, { payload: { digests } }) => {
      return { ...state, digests };
    },
    [combineActions(actions.getHotwByIdSuccess)]: (state, { payload: { publication } }) => {
      return { ...state, hotw: publication };
    },
    [combineActions(actions.setHotwQuery)]: (state, { payload: { hotwQuery } }) => {
      return { ...state, hotwQuery: hotwQuery || initialValues };
    },
    [combineActions(actions.setPromoAlertQuery)]: (state, { payload: { promoAlertQuery } }) => {
      return { ...state, promoAlertQuery: promoAlertQuery || initialValues };
    },
    [combineActions(actions.setCityRinkQuery)]: (state, { payload: { cityRinkQuery } }) => {
      return { ...state, cityRinkQuery: cityRinkQuery || { ...initialValues, style: 'City Rink' } };
    },
    [combineActions(actions.getPromoAlertByIdSuccess, actions.clonePromoAlertSuccess)]: (
      state,
      { payload: { publication } }
    ) => {
      return {
        ...state,
        promoAlert: {
          ...publication,
          startDate: publication.startDate
            ? moment(publication.startDate).utcOffset(0).format('YYYY-MM-DD @ h:mm a')
            : null,
          endDate: publication.endDate ? moment(publication.endDate).utcOffset(0).format('YYYY-MM-DD') : null,
          sendDate: publication.sendDate ? moment(publication.sendDate).utcOffset(0).format('YYYY-MM-DD') : null,
        },
      };
    },
    [combineActions(actions.getHotwByIdSuccess)]: (state, { payload: { publication } }) => {
      return {
        ...state,
        hotw: {
          ...publication,
          sendDate: publication.sendDate ? moment(publication.sendDate).utcOffset(0).format('YYYY-MM-DD') : null,
        },
      };
    },
    [combineActions(actions.updatePromoAlertSuccess)]: (state, { payload: { publication } }) => {
      return {
        ...state,
        promoAlert: {
          ...publication,
          startDate: publication.startDate
            ? moment(publication.startDate).utcOffset(0).format('YYYY-MM-DD @ h:mm a')
            : null,
          endDate: publication.endDate ? moment(publication.endDate).utcOffset(0).format('YYYY-MM-DD') : null,
          sendDate: publication.sendDate ? moment(publication.sendDate).utcOffset(0).format('YYYY-MM-DD') : null,
        },
      };
    },
    [combineActions(actions.updateHotwSuccess)]: (state, { payload: { publication } }) => {
      return {
        ...state,
        hotw: {
          ...publication,
          sendDate: publication.sendDate ? moment(publication.sendDate).utcOffset(0).format('YYYY-MM-DD') : null,
        },
      };
    },
    [combineActions(actions.getDigestsSuccess, actions.deleteDigestByIdSuccess)]: (state, { payload: { digests } }) => {
      return { ...state, digests };
    },
    [combineActions(
      actions.getPromoAlertsSuccess,
      actions.deletePromoAlertByIdSuccess,
      actions.searchPromoAlertsSuccess
    )]: (state, { payload: { publications } }) => {
      return { ...state, promoAlerts: publications };
    },
    [combineActions(actions.getHotwSuccess, actions.searchHOTWSuccess)]: (state, { payload: { publications } }) => {
      return { ...state, hotws: publications };
    },
    [actions.getTopPostsSuccess]: (state, { payload: { posts } }) => {
      return { ...state, topPosts: posts };
    },
    [actions.searchDigestsSuccess]: (state, { payload: { digests } }) => {
      return { ...state, searchPosts: digests };
    },
    [actions.recentPostsSuccess]: (state, { payload: { posts } }) => {
      return { ...state, recentPosts: posts };
    },
    [actions.clearRecentPosts]: state => {
      return { ...state, recentPosts: [], topPosts: [] };
    },
    [actions.clearCurrentDigestSuccess]: state => {
      return { ...defaultState };
    },
    [actions.getHotwListingByIdSuccess]: (state, { payload: { listing } }) => {
      const listings = { ...state.listings, [listing.id]: listing };
      return { ...state, listings };
    },
    [actions.getNewsAlertsSuccess]: (state, { payload: { publications } }) => {
      return { ...state, newsAlerts: publications };
    },
    [actions.getNewsAlertByIdSuccess]: (state, { payload: { publication } }) => {
      return { ...state, newsAlert: publication };
    },
  },
  defaultState
);

export default reducer;
